module.exports = __webpack_public_path__ + "img/uid-token-bg.f35ddf12.png";